<template>
  <v-container
    class="profile-view"
    fluid
    fill-height
    align-center
    justify-center
  >
  <page-title title="User profile"></page-title>
    <v-layout fluid column style="max-width: 300px; height: auto; text-align:center;" >
      <form :action="'/users/'+ $store.getters['user/details'].id" @submit.prevent="submit">
        <v-flex class="text-input-container">
          <label> Name </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.name"
            solo
            v-validate="'required|min:2|max:50'"
            :error-messages="errors.collect('Name')"
            data-vv-name="Name"
            counter="50"
          ></v-text-field>
        </v-flex>
        <v-flex class="text-input-container">
          <label> Email </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.username"
            solo
            v-validate="'required|email|max:50'"
            :error-messages="errors.collect('Email')"
            data-vv-name="Email"
            counter="50"
          ></v-text-field>
        </v-flex>
        <v-flex class="text-input-container">
          <label> Role </label>
          <v-select
            class="lg-select role-select"
            :items="roleList"
            item-text="label"
            item-value="id"
            solo
          
            v-validate="'required'"
            data-vv-name="Role"
            :error-messages="errors.collect('Role')"
            v-model="formData.role"
            disabled
          ></v-select>
        </v-flex>
        <v-btn
          color="accent"
          :disabled="!(isTouched && isFormDirty && isFormValid)"
          medium
          depressed=""
          type="submit"
          :loading="submitLoading"
          class="submit-button"
        >
          Submit
        </v-btn>
      </form>

      <LgDialog
          v-model="deleteDialog"
          :title="deleteUserDialogMessage.title"
          :content="deleteUserDialogMessage.message"
          primary-action-text="Delete"
          secondary-action-text="Cancel"
          :titleBg="colors.theme.warning"
          @primaryActionClick="deleteUser"
          @secondaryActionClick="deleteDialog = false"
          :primaryActionLoading="deleteLoading"
          
        >
          <template v-slot:dactivator="{ on }">
            <!-- <img v-if="showDeleteButton"
            :key="showDeleteButton"
              class="delete-user-img"
              
              :src="require('@/assets/delete.svg')"
            /> -->
            <v-btn
              color="primaryLight5 px-3 mt-5 delete-button"
              dark
              medium
              @click="deleteDialog = !deleteDialog"
              depressed=""
            >
              {{ $store.getters['user/details'].role === "OWNER" ? "Delete Business or Change Ownership": "Delete account" }}
            </v-btn>
          </template>
          <template v-slot:content>
            <v-container grid-list-md class="mt-2">
              {{deleteUserDialogMessage.message}}
              <v-layout wrap v-if="$store.getters['user/details'].role === 'OWNER'" column>
                <v-flex class="text-input-container mt-4">
                  <label>Transfer ownership to </label>
                  <v-select
                    class="lg-select role-select"
                    :items="userList"
                    item-text="username"
                    item-value="id"
                    solo
                    v-model="transferTo"
                    :disabled="userList.length < 1"
                    no-data-text="No users added"
                  ></v-select>
                </v-flex>
                <v-flex>
                  <v-text-field 
                  :rules="[rules.required, rules.min]"
                  v-model="currentPassword" 
                  label="Current password" 
                  type="password"
                  required></v-text-field>
                </v-flex>
              </v-layout>  
            </v-container>
          </template>
          <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primaryLight4"
              outline
              @click="deleteDialog = !deleteDialog"
            >
              Cancel
            </v-btn>
            <v-btn
              color="warning"
              :loading="deleteLoading"
              depressed
              @click="deleteUser"
              :disabled="$store.getters['user/details'].role === 'OWNER' && currentPassword.length < 8"
            >
              Delete
            </v-btn>
          </template>
        </LgDialog>
    </v-layout>
  </v-container>
</template>

<script>
import formMixins from '@/mixins/forms'
import EventBus from '@/event_bus'
import LgDialog from '@/components/LgDialog'
import userApi from '@/api/user'
import SideNav from '@/components/SideNav'
import ChangePassword from './ChangePassword'
import Verte from 'verte'
import routes from '@/route_names'
import 'verte/dist/verte.css'
export default {
  mixins: [formMixins],
  components: { Verte, LgDialog, SideNav, ChangePassword },
  name: 'Details',
  created(){
    this.getUsers()
  },
  data: function() {
    return {
      formData: { 
        name: this.$store.getters['user/details'].name, 
        username: this.$store.getters['user/details'].username, 
        role: this.$store.getters['user/details'].role, 
        id: this.$store.getters['user/details'].id 
      },
      users:[],
      deleteDialog: false,
      deleteLoading: false,
      authorizeDialog: true,
      currentPassword: '',
      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
      },
      transferTo: ''
    }
  },
  computed: {
    roleList() {
      const roles = [
        // { id: 'OWNER', label: 'Owner' },
        { id: 'ADMIN', label: 'Admin' },
        { id: 'GUEST', label: 'Guest' }
      ]
      if (this.$store.getters['user/details'].role === 'OWNER') {
        roles.unshift({ id: 'OWNER', label: 'Owner' })
      }
      return roles
    },
    userList: function() {
      const vm = this
      return this.users.filter(function(u) {
        return u.username !== vm.$store.getters['user/details'].username
      })
    },
    deleteUserDialogMessage(){
      if (this.$store.getters['user/details'].role === 'OWNER'){
        return {
          title: 'Confirm account deletion',
          message: 'Deleting an owner will delete the business and data associated with this account. You can transfer the ownership to one of your teammates. If you do not have a team member please add one first.'
        }
      }
      return {
          title: 'Confirm user deletion',
          message: 'If you want to continue deleting the account please provide your current password to proceed.'
        } 
    }
  },
  watch: {
    
    deleteDialog(value){
      this.currentPassword = ''
      this.transferTo = ''
    }
  },
  methods: {
    getUsers() {
      const vm = this
      vm.loading = true
      userApi.getUsers().then(function(data) {
        vm.users = data.data.results
        vm.loading = false
      })
    },
    getFormSubmitPromise: function() {
      const vm = this
      if(this.$store.getters['user/details'].username !== this.formData.username){

      }
      return this.$store
        .dispatch('user/updateDetails', this.formData)
        .then(function(res) {
          vm.setPristine()
          EventBus.$emit('SHOW_SNACK', {'msg': 'User details updated'})
        })
    },
    deleteUser() {
      const vm = this
      vm.deleteUserLoading = true
      if(this.$store.getters['user/details'].role === 'OWNER'){
        const d = {}
        d.current_password = this.currentPassword
        if(this.transferTo.length > 0){
          d.transfer_id = this.transferTo
          
        }
        userApi.deleteAccount(this.$store.getters['user/details'].id, d).then(function(res) {
          console.log(res)
          vm.deleteLoading = false
          vm.$router.push({
            name: routes.LOGIN
          })
        })
      }
      else{
        userApi.deleteUser(this.$store.getters['user/details'].id).then(function(res) {
        vm.deleteLoading = false
        vm.deleteDialog = false
      })
      }
    },
    showPasswordSidenav(){
      this.changePasswordSidenav = true
    }
  }
}
</script>

<style lang="stylus">
.profile-view {
    .text-input-container {
        margin-bottom 25px
        label {
          color: $color-primary-light-1
          font-weight: 500
        }
    }
    .lg-text-field {
        input {
            font-size 14px
        }
    }
    .lg-select {
        .v-select__selection {
            font-size 14px
        }
    }
    .text-input-container {
        input {
            text-align center
        }
    }
    .delete-button {
      position absolute
      right 15px
      bottom 15px  
    }
}
</style>
